import { withStyles } from '@material-ui/core';
import React from 'react';
import { formatESTDateTime } from '@dataGrid/gridUtilities';

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '64px',
    margin: '24px 0'
  },
  block: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  value: {
    fontSize: theme.headerTextFontSize16,
    fontWeight: 600,
    color: theme.disableButtonText
  },
  label: {
    color: theme.gridTextColor
  }
});

const ProHistoryHeader = ({ data, classes }) => {
  const { proId, createdOn, inPlanCount } = data;
  const details = [
    {
      label: 'PRO #',
      value: proId ?? '-'
    },
    {
      label: 'Created On',
      value: createdOn ? formatESTDateTime({ value: createdOn }) : '-'
    },
    {
      label: 'Included in Plans',
      value: inPlanCount ?? '-'
    }
  ];
  return (
    <div className={classes.container}>
      {details.map((item) => (
        <div className={classes.block} key={item.label}>
          <div className={classes.value}>{item.value}</div>
          <div className={classes.label}>{item.label}</div>
        </div>
      ))}
    </div>
  );
};

export default withStyles(styles)(ProHistoryHeader);
